import { Sun, Mail, Phone, MapPin } from "lucide-react";

const DEFAULT_DESCRIPTION =
  "Heliora pomaga w wyborze sprawdzonego instalatora fotowoltaiki i uzyskaniu rzetelnej wyceny.";

const DEFAULT_NAV_LINKS = [
  { id: "jak-to-dziala", label: "Jak to działa" },
  { id: "quiz", label: "Quiz" },
  { id: "faq", label: "FAQ" },
];

export default function Footer({
  description = DEFAULT_DESCRIPTION,
  navLinks = DEFAULT_NAV_LINKS,
  localization = null,
}) {
  return (
    <footer className="bg-brand-ink text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2">
          <div className="flex items-center gap-2">
            <span className="grid place-items-center h-9 w-9 rounded-full bg-brand-yellow text-brand-yellowFg">
              <Sun strokeWidth={2.4} className="h-5 w-5" />
            </span>
            <span className="font-heading font-extrabold text-xl tracking-tight">Heliora</span>
          </div>
          <p className="mt-4 text-white/60 max-w-sm leading-relaxed">
            {description}
          </p>
          {localization && (
            <p className="mt-3 text-white/50 text-sm max-w-sm leading-relaxed" data-testid="footer-localization">
              {localization}
            </p>
          )}
        </div>

        <div>
          <p className="font-heading font-semibold text-white">Firma</p>
          <ul className="mt-4 space-y-2 text-white/60">
            {navLinks.map((l) => (
              <li key={l.id}>
                <a href={`#${l.id}`} className="hover:text-brand-yellow transition-colors">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-heading font-semibold text-white">Kontakt</p>
          <ul className="mt-4 space-y-2 text-white/60 text-sm">
            <li className="flex items-center gap-2"><Phone className="h-4 w-4" /> +48 511 487 431</li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4" /> kontakt@heliora.com.pl</li>
            <li className="flex items-center gap-2"><MapPin className="h-4 w-4" /> Polska</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-white/50">
          <p>© {new Date().getFullYear()} Heliora Sp. z o.o. Wszelkie prawa zastrzeżone.</p>
          <div className="flex gap-5">
            <a href="#" className="hover:text-white transition-colors">Polityka prywatności</a>
            <a href="#" className="hover:text-white transition-colors">Regulamin</a>
            <a href="#" className="hover:text-white transition-colors">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
